export default __webpack_public_path__ + "static/media/stocks_header.5f6fbca6.svg";